<script setup lang="ts">

import {Dialog, DialogHeader, DialogScrollContent, DialogTitle, DialogTrigger} from "@/core/components/ui/dialog";
import {CustomerProfile} from "@/drug-interaction/components/DrugInteractionPatientProfile.vue";
import ProfileFormFields from "@/interview/components/instance-modal/profile/ProfileFormFields.vue";
import {ref} from "vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {BreastFeedingStatus, HepaticStatus} from "@/customer/interfaces/DeclaredInformation";

const props = defineProps<{
    profile: Omit<CustomerProfile, "id" | "is_dead">;
    loading?: boolean;
    name: string;
}>();

const emits = defineEmits<{
    (e: 'finish', profile: Omit<CustomerProfile, "id" | "is_dead">)
}>();

const open = defineModel<boolean>("open", {required: true});

const data = ref({
    weight: props.profile.weight || undefined,
    height: props.profile.height || undefined,
    amenorrhoea: props.profile.amenorrhoea || undefined,
    breast_feeding: props.profile.breast_feeding || undefined,
    breast_feeding_date: props.profile.breast_feeding_date || undefined,
    hepatic: props.profile.hepatic || undefined,
    dfg: props.profile.dfg || undefined,
    pathologies: props.profile.pathologies || [],
    allergies: props.profile.allergies || [],
});

const finish = () => {
    const profile: Omit<CustomerProfile, "id" | "is_dead"> = {
        weight: data.value.weight || null,
        height: data.value.height || null,
        amenorrhoea: data.value.amenorrhoea || null,
        breast_feeding: data.value.breast_feeding || BreastFeedingStatus.NONE,
        breast_feeding_date: data.value.breast_feeding_date || null,
        hepatic: data.value.hepatic || HepaticStatus.NONE,
        dfg: data.value.dfg || null,
        pathologies: data.value.pathologies || [],
        allergies: data.value.allergies || [],
    };

    emits('finish', profile);
};
</script>

<template>
  <Dialog v-model:open="open">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogScrollContent class="min-w-[70%] lg:min-w-[30%]" @interact-outside="(e) => e.preventDefault()">
      <DialogHeader>
        <DialogTitle>
          Profil de {{ name }}
        </DialogTitle>
      </DialogHeader>
      <ProfileFormFields v-model:data="data" />
      <div class="flex justify-end">
        <BaseButton primary :loading="loading" @click="finish">
          Terminer
        </BaseButton>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<style scoped>

</style>
